import { useState, useEffect } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import { useBusiness } from 'hooks/useBusiness';
import { useLocalization } from 'hooks/useLocalization';
import PageLoader from 'components/shared/PageLoader';
import { Alert, Box, Stack, Paper, Collapse } from '@mui/material'
import AlertBig from 'components/shared/AlertBig';

function useQuery() {
	return new URLSearchParams(useLocation().search);
}

function Pay() {
	const {
		bookingNumber: bookingNumberString,
		bookingToken,
		gatewayCode,
		redirectId: redirectIdString
	} = useParams<{
		bookingNumber?: string,
		bookingToken?: string,
		gatewayCode?: string,
		redirectId?: string
	}>();

	const { getStr, langCode } = useLocalization();
	const { sendRequest, getBizConfigVar, setPageTitle } = useBusiness();
	
	const [paymentStatus, setPaymentStatus] = useState<'loading' | 'received' | 'error'>('loading');
	const [errorString, setErrorString] = useState<string | null>(null);
	
	const bizContactEmails = getBizConfigVar('bizContactEmails');
	const bookingNumber = bookingNumberString ? parseInt(bookingNumberString) : undefined;
	const redirectId = redirectIdString ? parseInt(redirectIdString) : undefined;

	// Collect all query parameters except the known ones
	const query = useQuery();

	useEffect(() => {
		const standardGetVars = ['bookingNumber', 'bookingToken', 'gatewayCode', 'redirectId'];
	
		let hasConflict = false;

		const getVars: Record<string, string | number | undefined> = {
			bookingNumber,
			bookingToken,
			gatewayCode,
			redirectId,
		};

		query.forEach((value, key) => {
			if (standardGetVars.includes(key)) {
				throw new Error(`Query parameter '${key}' is reserved and cannot be used.`);
			}

			getVars[key] = value;
		});

        if (hasConflict) {
            setPaymentStatus('error');
            return;
        }

		console.log('getVars', getVars);
		console.log('query', query);

		sendRequest({
			type: 'confirmPayment',
			params: {
				getVars: getVars
			},
			onSuccess: (data) => {
				setPaymentStatus('received');
				setPageTitle(getStr('Payment_received'));
			},
			onError: (errorMessage) => {
				setPaymentStatus('error');
				setErrorString(errorMessage);
			}
		});
	}, []);

	return (
		<Box>
			<Collapse in={paymentStatus === 'loading'}>
				<PageLoader />
			</Collapse>
			<Collapse in={paymentStatus === 'received'}>
				<AlertBig
					severity="success"
					title={getStr('Thank_you_EXCL')}
				>
					<Box>
						{getStr('Payment_recieved_booking_confirmed')} {getStr('If_we_can_help_out_dont_hesitate_to')} {bizContactEmails.length > 0 ? (<a href={`mailto: ${bizContactEmails.join(',')}`}>{getStr('IF_CAN_HELP_PLEASE_DONT_HESITATE_TO_contact_us')}</a>) : (getStr('IF_CAN_HELP_PLEASE_DONT_HESITATE_TO_contact_us'))}.
					</Box>
				</AlertBig>
			</Collapse>
			<Collapse in={paymentStatus === 'error'}>
				<AlertBig
					severity="error"
					title={getStr('Error')}
				>
					<Box>
						{getStr('ERROR_TRY_AGAIN_OR_CONTACT_ERROR_INFO_RETRIEVED_PART_1')} <a href={getBizConfigVar('appRootUrlToUse') + '/#/' + getStr('PUBLIC_APP_URL_booking') + '/' + bookingNumber + '/' + bookingToken}>{getStr('ERROR_TRY_AGAIN_OR_CONTACT_ERROR_INFO_RETRIEVED_PART_2_try_again')}</a> {getStr('ERROR_TRY_AGAIN_OR_CONTACT_ERROR_INFO_RETRIEVED_PART_3')}:
					</Box>
					<Paper sx={{ backgroundColor: 'transparent', padding: '10px', mt: '15px' }}><i>{errorString}</i></Paper>
				</AlertBig>
			</Collapse>
		</Box>
	);
}

export default Pay;